@if (!workspaceResolved()) {
  <app-loading-indicator>Loading tasks...</app-loading-indicator>
} @else if (!currentTeamWorkspace) {
  <app-sidebar-item
    class="rounded [&:not(.drag-over)]:hover:bg-hover"
    *nestedFor="
      let item of items;
      let index = index;
      let depth = depth;
      let expandable = expandable;
      let expanded = expanded;
      stateKey: StateKey.taskingSidebarProjectsTree + team?.id
    "
    [title]="item.title"
    [icon]="item.icon"
    [iconColor]="item.color"
    [depth]="depth + (team ? 2 : 0)"
    [expandable]="expandable"
    [expanded]="expanded.value"
    [minimized]="minimized"
    [active]="currentTeamId === team?.id && sidebarFilter === item.id"
    (onExpand)="expanded.next($event)"
    (appClick)="selectFilter(item.id)"
    [appSidebarContextMenu]="item.id"
    [appSidebarContextMenuTenantId]="team?.id"
    #elRef
    appDroppable
    appDroppableHoverClass="drag-over"
    [appDroppablePredicate]="dndPredicate"
    (appDroppableDrop)="dndDrop($event, item.id, index)"
  />

  <app-sidebar-items-divider />
  <app-side-bar-projects (selectFilter)="selectFilter($event)" [team]="team" />
} @else {
  @if (currentMemberTenant) {
    <section class="rail-section">
      <button
        type="button"
        class="rail-section-heading"
        [attr.aria-expanded]="myWorkspaceExpanded()"
        (click)="myWorkspaceExpanded.set(!myWorkspaceExpanded())"
      >
        <app-icon name="sapphire-chevron-right" size="s" [class.rotate-90]="myWorkspaceExpanded()" />
        My Workspace
      </button>

      @if (myWorkspaceExpanded()) {
        <div class="rail-section-content">
          @for (item of primaryItems; track item.id; let index = $index) {
            <ng-container
              [ngTemplateOutlet]="navigationItem"
              [ngTemplateOutletContext]="{ item: item, index: index, team: currentMemberTenant }"
            />
          }

          <button
            type="button"
            class="rail-view-more"
            [attr.aria-expanded]="moreExpanded()"
            (click)="moreExpanded.set(!moreExpanded())"
          >
            <app-icon name="sapphire-chevron-right" size="s" [class.rotate-90]="moreExpanded()" />
            View more
          </button>

          @if (moreExpanded()) {
            <ng-container
              *nestedFor="
                let item of moreItems;
                let index = index;
                let depth = depth;
                let expandable = expandable;
                let expanded = expanded;
                stateKey: StateKey.taskingSidebarProjectsTree + currentMemberTenant.id
              "
            >
              <app-sidebar-item
                data-testid="rail-row"
                [attr.data-filter]="item.id"
                data-tenant="member"
                class="rail-navigation-item rounded [&:not(.drag-over)]:hover:bg-hover"
                [title]="item.title"
                [icon]="item.icon"
                [iconColor]="item.color"
                [depth]="depth"
                [expandable]="expandable"
                [expanded]="expanded.value"
                [active]="currentTeamId === currentMemberTenant.id && sidebarFilter === item.id"
                (onExpand)="expanded.next($event)"
                (appClick)="selectFilter(item.id, currentMemberTenant)"
                [appSidebarContextMenu]="item.id"
                [appSidebarContextMenuTenantId]="currentMemberTenant.id"
                [appSidebarContextMenuRail]="true"
                appSidebarContextMenuRailScope="mine"
                #elRef
                appDroppable
                appDroppableHoverClass="drag-over"
                [appDroppablePredicate]="dndPredicate"
                (appDroppableDrop)="dndDrop($event, item.id, index, currentMemberTenant)"
              />

              @if (item.id === 'snoozed') {
                <app-sidebar-item
                  data-testid="rail-row"
                  data-filter="following"
                  data-tenant="member"
                  class="rail-navigation-item rounded"
                  [title]="'Following'"
                  icon="bell"
                  [comingSoon]="true"
                  [depth]="depth"
                  appSidebarContextMenu="following"
                  [appSidebarContextMenuTenantId]="currentMemberTenant.id"
                  [appSidebarContextMenuRail]="true"
                  appSidebarContextMenuRailScope="mine"
                />
              }
            </ng-container>
          }

          <div class="rail-item-divider"></div>

          <app-side-bar-projects
            [depth]="0"
            [rail]="true"
            railScope="mine"
            [tenantId]="currentMemberTenant.id"
            (selectFilter)="selectFilter($event, currentMemberTenant)"
            [team]="team"
          />

          <div class="rail-item-divider"></div>

          <app-knowledge-items-rail
            [sidebarSplitViewKey]="SidebarSplitViewKey.tasking"
            [tenantId]="currentMemberTenant.id"
            [team]="currentMemberTenant"
            [knotsRailEntries]="pinnedMenus.mine.knots"
            [tagsRailEntries]="pinnedMenus.mine.tags"
            knotsManageLabel="Manage Pinned Knots"
            tagsManageLabel="Manage Pinned Tags"
          />
        </div>
      }
    </section>

    <div class="rail-divider"></div>
  }

  <app-sidebar-shared-placeholder [headerTemplate]="currentMemberTenant ? tasksSharedHeader : undefined" />

  <div class="rail-divider"></div>

  <section class="rail-section">
    <button
      type="button"
      class="rail-section-heading"
      [attr.aria-expanded]="teamWorkspaceExpanded()"
      (click)="teamWorkspaceExpanded.set(!teamWorkspaceExpanded())"
    >
      <app-icon name="sapphire-chevron-right" size="s" [class.rotate-90]="teamWorkspaceExpanded()" />
      Team Workspace
    </button>

    @if (teamWorkspaceExpanded()) {
      <div class="rail-section-content">
        <button
          type="button"
          class="rail-workspace-row"
          [attr.aria-expanded]="currentTeamWorkspaceExpanded()"
          (click)="toggleCurrentTeamWorkspace()"
        >
          <app-icon name="sapphire-chevron-right" size="s" [class.rotate-90]="currentTeamWorkspaceExpanded()" />
          <span
            class="rail-workspace-avatar"
            [style.background-color]="workspaceColor(currentTeamWorkspace)"
            [style.color]="currentTeamWorkspace.color ? null : workspacePalette(currentTeamWorkspace).text"
          >
            {{ currentTeamWorkspaceInitials }}
          </span>
          <span class="rail-workspace-title">{{ currentTeamWorkspace.title }}</span>
        </button>

        @if (currentTeamWorkspaceExpanded()) {
          <div class="rail-team-workspace-content">
            @for (item of teamPrimaryItems; track item.id; let index = $index) {
              <ng-container
                [ngTemplateOutlet]="navigationItem"
                [ngTemplateOutletContext]="{ item: item, index: index, depth: 0, team: currentTeamTenant }"
              />

              @if (index === 0) {
                <app-sidebar-item
                  data-testid="rail-row-assigned-to-me"
                  data-filter="assigned_to_me"
                  data-tenant="team"
                  class="rail-navigation-item rounded"
                  [title]="'Assigned to me'"
                  icon="sapphire-user-plus"
                  [depth]="0"
                  [active]="currentTeamId === currentTeamTenant?.id && sidebarFilter === 'assigned_to_me'"
                  (appClick)="selectFilter('assigned_to_me', currentTeamTenant)"
                  appSidebarContextMenu="assigned_to_me"
                  [appSidebarContextMenuTenantId]="currentTeamTenant?.id"
                  [appSidebarContextMenuRail]="true"
                  appSidebarContextMenuRailScope="team"
                />
              }
            }

            <button
              type="button"
              class="rail-view-more rail-team-view-more"
              [attr.aria-expanded]="teamMoreExpanded()"
              (click)="teamMoreExpanded.set(!teamMoreExpanded())"
            >
              <app-icon name="sapphire-chevron-right" size="s" [class.rotate-90]="teamMoreExpanded()" />
              View more
            </button>

            @if (teamMoreExpanded()) {
              <ng-container
                *nestedFor="
                  let item of moreItems;
                  let index = index;
                  let depth = depth;
                  let expandable = expandable;
                  let expanded = expanded;
                  stateKey: StateKey.taskingSidebarProjectsTree + currentTeamTenant?.id
                "
              >
                <app-sidebar-item
                  data-testid="rail-row"
                  [attr.data-filter]="item.id"
                  data-tenant="team"
                  class="rail-navigation-item rounded [&:not(.drag-over)]:hover:bg-hover"
                  [title]="item.title"
                  [icon]="item.icon"
                  [iconColor]="item.color"
                  [depth]="depth"
                  [expandable]="expandable"
                  [expanded]="expanded.value"
                  [active]="currentTeamId === currentTeamTenant?.id && sidebarFilter === item.id"
                  (onExpand)="expanded.next($event)"
                  (appClick)="selectFilter(item.id, currentTeamTenant)"
                  [appSidebarContextMenu]="item.id"
                  [appSidebarContextMenuTenantId]="currentTeamTenant?.id"
                  [appSidebarContextMenuRail]="true"
                  appSidebarContextMenuRailScope="team"
                  #elRef
                  appDroppable
                  appDroppableHoverClass="drag-over"
                  [appDroppablePredicate]="dndPredicate"
                  (appDroppableDrop)="dndDrop($event, item.id, index, currentTeamTenant)"
                />

                @if (item.id === 'snoozed') {
                  <app-sidebar-item
                    data-testid="rail-row"
                    data-filter="following"
                    data-tenant="team"
                    [title]="'Following'" icon="bell" [depth]="depth"
                    [active]="currentTeamId === currentTeamTenant?.id && sidebarFilter === 'following'"
                    (appClick)="selectFilter('following', currentTeamTenant)"
                    [appSidebarContextMenu]="'following'"
                    [appSidebarContextMenuTenantId]="currentTeamTenant?.id"
                    [appSidebarContextMenuRail]="true"
                    appSidebarContextMenuRailScope="team"
                  />
                }
              </ng-container>
            }
          </div>
        }

        <div class="rail-item-divider"></div>

        <app-side-bar-projects
          title="Team Projects"
          [depth]="0"
          [rail]="true"
          railScope="team"
          [tenantId]="currentTeamWorkspace.id"
          (selectFilter)="selectFilter($event, currentTeamTenant)"
          [team]="currentTeamTenant"
        />

        <div class="rail-item-divider"></div>

        <app-knowledge-items-rail
          knotsTitle="Team Knots"
          tagsTitle="Team Tags"
          [sidebarSplitViewKey]="SidebarSplitViewKey.tasking"
          [tenantId]="currentTeamWorkspace.id"
          [team]="currentTeamTenant"
          [depth]="0"
          [knotsRailEntries]="pinnedMenus.team.knots"
          [tagsRailEntries]="pinnedMenus.team.tags"
          knotsManageLabel="Manage Team Knots"
          tagsManageLabel="Manage Team Tags"
        />
      </div>
    }
  </section>
}

@if (workspaceResolved() && !currentTeamWorkspace) {
  <app-sidebar-items-divider />
  <app-knowledge-items-rail
    [sidebarSplitViewKey]="SidebarSplitViewKey.tasking"
    [tenantId]="currentTeamId"
    [team]="team"
  />
}

<ng-template #navigationItem let-item="item" let-index="index" let-depth="depth" let-team="team">
  <app-sidebar-item
    data-testid="rail-row"
    [attr.data-filter]="item.id"
    [attr.data-tenant]="!team ? 'personal' : team === currentTeamTenant ? 'team' : 'member'"
    class="rail-navigation-item rounded [&:not(.drag-over)]:hover:bg-hover"
    [title]="item.title"
    [icon]="item.icon"
    [iconColor]="item.color"
    [depth]="depth || 0"
    [active]="(currentTeamId ?? null) === (team?.id ?? null) && sidebarFilter === item.id"
    (appClick)="selectFilter(item.id, team)"
    [appSidebarContextMenu]="item.id"
    [appSidebarContextMenuTenantId]="team?.id"
    [appSidebarContextMenuRail]="!!team && (team === currentMemberTenant || team === currentTeamTenant) && item.id !== 'search_results'"
    [appSidebarContextMenuRailScope]="team === currentTeamTenant ? 'team' : 'mine'"
    #elRef
    appDroppable
    appDroppableHoverClass="drag-over"
    [appDroppablePredicate]="dndPredicate"
    (appDroppableDrop)="dndDrop($event, item.id, index, team)"
  />
</ng-template>

<!--
  The Shared header with a menu. Shared sits outside My Workspace's section, but it is the member's: its
  menu names the member workspace, never the team the rail happens to show. A right-click opens the menu
  and does not toggle the section; a click toggles it exactly as the default header does.
-->
<ng-template #tasksSharedHeader let-expanded="expanded" let-toggle="toggle">
  <button
    type="button"
    class="shared-placeholder-header"
    [attr.aria-expanded]="expanded"
    (click)="toggle()"
    appSidebarContextMenu="shared"
    [appSidebarContextMenuTenantId]="currentMemberTenant?.id"
    [appSidebarContextMenuRail]="true"
    appSidebarContextMenuRailScope="mine"
  >
    <app-icon name="sapphire-chevron-right" size="s" [class.rotate-90]="expanded" />
    Shared
  </button>
</ng-template>

<ng-template #afterDropTemplate let-item="item">
  <app-task-quick-form
    [showMore]="true"
    [autofocus]="true"
    [title]="item.title"
    [task]="item"
    (more)="handleMore($event)"
    (close)="handleClose()"
    [transferredDraft]="true"
  />
</ng-template>
